// src/admin/adminAuth.js

const ADMIN_TOKEN_KEY = "admin_token";
const ADMIN_ME_KEY = "admin_me";
const ADMIN_EXPIRES_AT_KEY = "admin_expires_at";

function safeJsonParse(raw) {
  try {
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function parseJwt(token) {
  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    const json =
      typeof window !== "undefined" && typeof window.atob === "function"
        ? window.atob(padded)
        : null;
    return json ? JSON.parse(json) : null;
  } catch {
    return null;
  }
}

export function getAdminToken() {
  try {
    return localStorage.getItem(ADMIN_TOKEN_KEY) || "";
  } catch {
    return "";
  }
}

export function getAdminMe() {
  try {
    return safeJsonParse(localStorage.getItem(ADMIN_ME_KEY));
  } catch {
    return null;
  }
}

export function getAdminExpiresAt() {
  try {
    const raw = localStorage.getItem(ADMIN_EXPIRES_AT_KEY);
    const n = raw ? Number(raw) : 0;
    return Number.isFinite(n) ? n : 0;
  } catch {
    return 0;
  }
}

export function isAdminTokenExpired(token = getAdminToken()) {
  if (!token) return true;

  const explicitExpiry = getAdminExpiresAt();
  if (explicitExpiry > 0) {
    return Date.now() >= explicitExpiry - 15_000;
  }

  const payload = parseJwt(token);
  const expMs = Number(payload?.exp || 0) * 1000;
  if (!expMs) return false;

  return Date.now() >= expMs - 15_000;
}

export function setAdminSession(token, me, expiresAtEpochMs) {
  if (!token || !me) return;

  try {
    localStorage.setItem(ADMIN_TOKEN_KEY, token);
    localStorage.setItem(ADMIN_ME_KEY, JSON.stringify(me));

    if (expiresAtEpochMs) {
      localStorage.setItem(ADMIN_EXPIRES_AT_KEY, String(expiresAtEpochMs));
    } else {
      const payload = parseJwt(token);
      const expMs = Number(payload?.exp || 0) * 1000;
      if (expMs) {
        localStorage.setItem(ADMIN_EXPIRES_AT_KEY, String(expMs));
      } else {
        localStorage.removeItem(ADMIN_EXPIRES_AT_KEY);
      }
    }
  } catch {
    // ignore storage failures
  }
}

export function clearAdminSession() {
  try {
    localStorage.removeItem(ADMIN_TOKEN_KEY);
    localStorage.removeItem(ADMIN_ME_KEY);
    localStorage.removeItem(ADMIN_EXPIRES_AT_KEY);
  } catch {
    // ignore
  }
}

export function hasAdminSession() {
  const token = getAdminToken();
  const me = getAdminMe();
  if (!token || !me) return false;
  if (isAdminTokenExpired(token)) {
    clearAdminSession();
    return false;
  }
  return true;
}